import { useCallback, useContext } from "react";

import { Select } from "antd";
import { useDispatch } from "react-redux";

import { RVFormFloatingLabel, RVFormItem } from "@regal-voice/ui";
import { JourneyFormContext } from "Pages/orchestration/Pages/journeys/JourneyEditPage/Components/JourneyBuilder/shared/Contexts/JourneyFormContext";
import { setFields } from "Services/state/journeys/JourneyStateSlice";

import { unflattenFields } from "../../../Utils/utils";

import styles from "../ConditionalFormItems.module.scss";

export function ConditionalNodeEventComparator({
    formValues,
    isEventCondtional,
}: {
    formValues: any;
    isEventCondtional: boolean;
}): JSX.Element {
    // why do we need to assert this?
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { formSubmited } = useContext(JourneyFormContext)!;
    const dispatch = useDispatch();
    const validateEventOperator = useCallback(
        async (_: any, eventOperator: any) => {
            if (!formSubmited || !isEventCondtional) {
                return Promise.resolve();
            }
            if (!eventOperator) {
                return Promise.reject("Event Operator is required");
            }
            return Promise.resolve();
        },
        [formSubmited, isEventCondtional]
    );

    if (!isEventCondtional) {
        return <></>;
    }
    return (
        <RVFormFloatingLabel name="eventOperator" key={`floating-event-Operator`}>
            <RVFormItem
                name="eventOperator"
                key={`form-event-Operator`}
                className={styles.formItem}
                initialValue="isSet"
                rules={[{ validator: validateEventOperator, message: "Event operator is required." }]}
                label={`Operator`}
            >
                <Select
                    onChange={(value) => {
                        dispatch(
                            setFields(
                                unflattenFields({
                                    ...formValues,
                                    eventOperator: value,
                                    ...(value == "isNotSet" ? { filters: [] } : {}),
                                })
                            )
                        );
                    }}
                    data-testid={"select-eventOperator"}
                >
                    <Select.Option value="isNotSet">Does Not Exist</Select.Option>
                    <Select.Option value="isSet">Exists</Select.Option>
                </Select>
            </RVFormItem>
        </RVFormFloatingLabel>
    );
}
